import { calTotal } from "./methods/calTotal";
import { divisionArrange } from "./methods/divisionArrange";
import { getLatestCountDownLimit } from "./methods/getLatestCountDownLimit";

export default {
  calTotal,
  divisionArrange,
  getLatestCountDownLimit,
};
